import { useContext } from 'react'
import {
  CrmIntegrationChatAvailabilityContext,
  type CrmIntegrationChatAvailabilityState,
} from './CrmIntegrationChatAvailabilityProvider'

export type { CrmIntegrationChatAvailabilityState } from './CrmIntegrationChatAvailabilityProvider'

export const useCrmIntegrationChatAvailability =
  (): CrmIntegrationChatAvailabilityState => {
    const context = useContext(CrmIntegrationChatAvailabilityContext)

    if (context === undefined) {
      throw new Error(
        'useCrmIntegrationChatAvailability must be used within CrmIntegrationChatAvailabilityProvider',
      )
    }

    return context
  }
